import React, { useContext } from 'react';
import { Helmet } from 'react-helmet';
import { EntryContext } from '../contexts/entryContext';
import AgeVerification from '../components/AgeVerification';
import InnerLayout from '../components/layouts/InnerLayout';
import DisplayContent from '../utils/DisplayContent';

const AgeVerificationPage = () => {
    const { game, siteAssets } = useContext(EntryContext);

    return (
        <>
            <InnerLayout logo={true} pageClass={`age-verification-page`}>
                <Helmet>
                    <title>
                        {siteAssets?.ageVerificationPageTitle ?? 'Age Verification'} - {siteAssets?.title ?? 'Scratch Connect'}
                    </title>
                </Helmet>
                <AgeVerification />
            </InnerLayout>
            <footer>
                <DisplayContent note='Age Verification Footer Callout' isVisible={game?.ageVerificationFooterCalloutImage?.ref}>
                    <div id='age-verification-footer-callout' className='age-verification-footer-callout'>
                        <img src={game?.ageVerificationFooterCalloutImage?.ref} alt={game?.ageVerificationFooterCalloutImage?.alt} />
                    </div>
                </DisplayContent>
            </footer>
        </>
    );
};

export default AgeVerificationPage;
